import { SelectOption } from "./selectOption";

export type IdLabelDictionary = Record<number, string>;
export interface StaticData {
  classifications: IdLabelDictionary;
  clients: IdLabelDictionary;
  groups: IdLabelDictionary;
  teams: IdLabelDictionary; 
  users: IdLabelDictionary;
}
export const staticDataInitialState: StaticData = {
  classifications: {},
  clients: {},
  groups: {},
  teams: {},
  users: {},
};

export const convertToSelectOptions = (data: IdLabelDictionary): SelectOption[] => {
  return Object.entries(data)
    .map(([id, label]) => ({ id: Number(id), label }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
